import { post } from './API';

/**
 * Abandoned-basket follow-up messaging. Generates AI content and sends it on
 * the chosen channel (email | whatsapp) for a given booking.
 */
const FollowUpService = {
  // Returns { success, channel, content } where content is
  // { subject, html } for email or { text } for whatsapp.
  async generate(bookingId, channel) {
    const response = await post('bookings/followup-generate', { bookingId, channel });
    return response?.data?.data;
  },

  // Returns { success, channel, followUp } where followUp is the persisted
  // { channel, sent_by, sent_at } record for the just-sent message.
  async send(bookingId, channel, content) {
    const response = await post('bookings/followup-send', { bookingId, channel, content });
    return response?.data?.data;
  },
};

export default FollowUpService;
